// Parse fractions like "12 1/2", "12-1/2", "12.5", "1/2" into decimal
export function parseFraction(value) {
  if (!value || value === "") return 0;
  const str = String(value).trim();
  
  // Already a number
  if (!isNaN(parseFloat(str)) && !str.includes('/')) {
    return parseFloat(str);
  }
  
  // Match patterns like "12 1/2", "12-1/2", "12 3/4"
  const mixedMatch = str.match(/^(\d+)\s*[-\s]\s*(\d+)\s*\/\s*(\d+)$/);
  if (mixedMatch) {
    const whole = parseInt(mixedMatch[1]);
    const num = parseInt(mixedMatch[2]);
    const den = parseInt(mixedMatch[3]);
    return whole + (num / den);
  }
  
  // Match simple fraction like "1/2", "3/4"
  const fractionMatch = str.match(/^(\d+)\s*\/\s*(\d+)$/);
  if (fractionMatch) {
    return parseInt(fractionMatch[1]) / parseInt(fractionMatch[2]);
  }
  
  // Try parsing as float
  return parseFloat(str) || 0;
}

// Convert cm to inches
export function cmToInches(cm) {
  return cm / 2.54;
}

// Convert inches to cm
export function inchesToCm(inches) {
  return inches * 2.54;
}

// Convert decimal to fraction display (for nicer display)
export function decimalToFraction(decimal) {
  if (!decimal || decimal === 0) return "";
  const whole = Math.floor(decimal);
  const frac = decimal - whole;
  
  // Common fractions in woodworking - up to 1/32"
  const fractions = [
    [1/32, "1/32"], [1/16, "1/16"], [3/32, "3/32"], [1/8, "1/8"],
    [5/32, "5/32"], [3/16, "3/16"], [7/32, "7/32"], [1/4, "1/4"],
    [9/32, "9/32"], [5/16, "5/16"], [11/32, "11/32"], [3/8, "3/8"],
    [13/32, "13/32"], [7/16, "7/16"], [15/32, "15/32"], [1/2, "1/2"],
    [17/32, "17/32"], [9/16, "9/16"], [19/32, "19/32"], [5/8, "5/8"],
    [21/32, "21/32"], [11/16, "11/16"], [23/32, "23/32"], [3/4, "3/4"],
    [25/32, "25/32"], [13/16, "13/16"], [27/32, "27/32"], [7/8, "7/8"],
    [29/32, "29/32"], [15/16, "15/16"], [31/32, "31/32"]
  ];
  
  // Find closest fraction
  let closest = null;
  let minDiff = 1;
  for (let i = 0; i < fractions.length; i++) {
    const diff = Math.abs(frac - fractions[i][0]);
    if (diff < minDiff) {
      minDiff = diff;
      closest = fractions[i];
    }
  }
  
  // If very close to a fraction (within 0.005), use it
  if (closest && minDiff < 0.005) {
    if (whole === 0) return closest[1];
    return whole + " " + closest[1];
  }
  
  // Otherwise return decimal with 4 places
  return decimal.toFixed(4);
}
